import {
    WpIndividual,
    WpPeopleDetail,
    WpViewDistributionData,
} from '../../core';

export function createDistributionData(
    row: WpIndividual | WpPeopleDetail,
): WpViewDistributionData[] {
    const distributionData: WpViewDistributionData[] = [];

    const indexMap = [
        {
            percentage: row?.winning,
            classList: 'cmps-cdk-bg-gradient-green-100-0',
        },
        {
            percentage: row?.neutral,
            classList: 'cmps-cdk-bg-gradient-grey-400-0',
        },
        {
            percentage: row?.losing,
            classList: 'cmps-cdk-bg-gradient-red-100-0',
        },
    ];

    indexMap.forEach((e) => {
        const percentageWidth = e.percentage * 100;
        if (percentageWidth > 0) {
            const data: WpViewDistributionData = {
                percentage: e.percentage,
                percentageWidth,
                classList: e.classList,
            };
            distributionData.push(data);
        }
    });

    return distributionData;
}
